

// Datos del cliente. Unico lugar donde se definen: al clonar el proyecto para
// otro cliente solo hay que tocar este archivo.

// La carpeta ./comodin2 del proyecto original no existe en public/, por eso el
// favicon de los meta tags aparecia roto. Usamos los assets que si estan.
export const imagenes = {
    urlImage:'/fans'
}

export const institucion = {
    nombre:      'Universidad Católica',
    nombreLargo: 'Universidad Católica Nuestra Señora de la Asunción',
    sigla:       'UC',
    email:       'info@universidadcatolica.edu.py',
    telefono:    '021 441 044',
    direccion:   'Independencia Nacional y Comuneros, Asunción - Paraguay'
}

export const redesSociales = {
    sitio:     'https://universidadcatolica.edu.py/',
    facebook:  'https://www.facebook.com/unicatolicapy',
    x:         'https://x.com/unicatolicapy',
    instagram: 'https://www.instagram.com/unicatolicapy/',
    youtube:   'https://www.youtube.com/channel/UCdrupjf9CzpKZe0YPyQh7Ew'
}

export const metaTags = {

    generales:{
        imgLogo:`${imagenes.urlImage}/logo-menu.png`,
        color:"#003366",
        viewport:"width=device-width, initial-scale=1",
        manifest:"%PUBLIC_URL%/manifest.json",
        charSet:"utf-8"

    },
    bonosHome:{
    title:"Beneficios con descuento - Universidad Católica",
    description:"Beneficios y descuentos exclusivos para la comunidad de la Universidad Católica."
    },
    contacto:{
        title:"Contactanos - Universidad Católica",
        description:"Ponete en contacto con la Universidad Católica Nuestra Señora de la Asunción."
        },
        influencer:{
            title:"Alianzas - Universidad Católica",
            description:"Buscamos alianzas de difusión para el catálogo de beneficios de la Universidad Católica."
        },
        comercial:{
            title:"Comercios adheridos - Universidad Católica",
            description:"Sumá tu comercio al catálogo de convenios y beneficios de la Universidad Católica."
        },
        repre:{
            title:"Representantes - Universidad Católica",
            description:"Representantes comerciales del programa de convenios y beneficios de la Universidad Católica."
        },
        home:{
            title:"Catálogo de beneficios, promociones y convenios de la Universidad Católica",
            description:"Descubrí todos los beneficios, promociones y convenios vigentes para estudiantes, docentes, funcionarios y egresados de la Universidad Católica Nuestra Señora de la Asunción."
        }
        ,
        juegosHome:{
            title:"Novedades - Universidad Católica",
            description:"Novedades y actividades de la Universidad Católica Nuestra Señora de la Asunción."
        }
        ,
        login:{
            title:"Iniciá sesión - Universidad Católica",
            description:"Accedé con tu cuenta para ver los beneficios y convenios exclusivos de la Universidad Católica."
        }
        ,
        pagaHome:{
            title:"Convenios - Universidad Católica",
            description:"Convenios institucionales de la Universidad Católica Nuestra Señora de la Asunción."
        }
        ,
        promocionesHome:{
            title:"Promociones y descuentos - Universidad Católica",
            description:"Promociones, descuentos y ofertas de los comercios adheridos al programa de beneficios de la Universidad Católica."
        },
        puntosHome:{
            title:"Tus beneficios - Universidad Católica",
            description:"Consultá los beneficios disponibles para la comunidad de la Universidad Católica."
        },
        recuperarHome:{
            title:"Recuperar contraseña - Universidad Católica",
            description:"Recuperá tu usuario y contraseña del catálogo de beneficios de la Universidad Católica."
        },
        registerHome:{
            title:"Registrate - Universidad Católica",
            description:"Registrate para acceder al catálogo de beneficios, promociones y convenios de la Universidad Católica."
        },
        sociosHome:{
            title:"Comercios y convenios - Universidad Católica",
            description:"Conocé los comercios e instituciones con convenio vigente con la Universidad Católica."
        },
        sorteosHome:{
            title:"Sorteos - Universidad Católica",
            description:"Sorteos y actividades para la comunidad de la Universidad Católica."
        },
        tutorialesHome:{
            title:"Preguntas frecuentes - Universidad Católica",
            description:"Todo lo que necesitás saber para aprovechar el catálogo de beneficios de la Universidad Católica."
        },
        notasHome:{
            title:"Novedades y notas - Universidad Católica",
            description:"Notas, novedades y comunicados de la Universidad Católica Nuestra Señora de la Asunción."
        },
        carritoHome:{
            title:"Tu carrito"
        },
        cuentaHome:{
            title:"Editar tu cuenta"
        },
        editcHome:{
            title:"Editar contraseña"
        },
        ticketsHome:{
            title:"Tus Tickets"
        },
        cambiarC:{
            title:"Cambiar contraseña"
        },
        pedidosHome:{
            title:"Tus pedidos"
        }


}

// export default configuraciones;
